import Axios from 'axios';

const get = (url, ttlsec = 60) => new Promise((resolve, reject) => {
  if (!url) return reject(new Error('no url found'));
  const id = url.replace(/[^a-z0-9]/gmi, '');
  const now = new Date();
  if (window.localStorage && JSON.parse(localStorage.getItem(id))) {
    const cached = JSON.parse(localStorage.getItem(id));
    if (cached.expire > now.getTime()) {
      return resolve({ data: cached.data });
    }
  }

  Axios.get(url).then(res => {
    if (ttlsec) {
      const item = {
        expire: now.getTime() + parseInt(ttlsec, 10) * 1000,
        expireString: now.toISOString(),
        data: res.data,
      };
      localStorage.setItem(id, JSON.stringify(item));
    }
    return resolve(res);
  }).catch(err => reject(err));
});

export default {
  get
};



/** WEBPACK FOOTER **
 ** ./core_modules/AxiosCache/index.js
 **/